export type ReportComponentEmbedFetchMode = 'authenticated' | 'public-component' | 'public-memo';

export const getSharedMemoIdFromLocation = (): string | undefined => {
    const match = window.location.pathname.match(/^\/(?:s|shared)\/memos\/([^/]+)/);

    return match?.[1];
};

export const getAuthenticatedMemoIdFromLocation = (): string | undefined => {
    const match = window.location.pathname.match(/^\/memos\/([^/]+)/);

    return match?.[1];
};

export const isPublicReportComponentRoute = (): boolean =>
    /^\/(?:s|shared)\/report-components\/[^/]+/.test(window.location.pathname);

export const canResizeReportComponentEmbed = (
    editorEditable: boolean,
    fetchMode: ReportComponentEmbedFetchMode,
): boolean => editorEditable && fetchMode === 'authenticated';
